// import React from 'react'
// import './Breadcrum.css'
// import arrow_icon from '../Assets/Frontend_Assets/breadcrum_arrow.png'
// const Breadcrum = (props) => {
//     const {product}=props;
//   return (
//     <div className='breadcrum'>
//       HOME <img src={arrow_icon} alt=""/>SHOP <img src={arrow_icon} alt=""/>{product.category} <img src={arrow_icon} alt=""/>{product.name}
//     </div>
//   )
// }

// export default Breadcrum
import React from 'react';
import './Breadcrum.css';
import arrow_icon from '../Assets/Frontend_Assets/breadcrum_arrow.png';

const Breadcrum = (props) => {
  const { product } = props;

  if (!product) {
    return <div>Product not available</div>;
  }

  return (
    <div className='breadcrum'>
      HOME <img src={arrow_icon} alt=""/> SHOP <img src={arrow_icon} alt=""/> {product.category} <img src={arrow_icon} alt=""/> {product.name}
    </div>
  );
};

export default Breadcrum;

